import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		authState: {
			token: localStorage.getItem("token") || "",
			loggedUser: localStorage.getItem("logged") != "undefined" ? JSON.parse(localStorage.getItem("logged")) : "",
			status: "notlogged"
		},
		promotorCode: localStorage.getItem("promotorCode") || ""
	},
	getters: {
		isAuthenticated: (state) => !!state.authState.token,
		authStatus: (state) => state.authState.status,
		loggedUser: (state) => state.authState.loggedUser,
		promotorCode: (state) => state.promotorCode
	},
	mutations: {
		authSuccess(state, { token, user }) {
			state.authState.status = "logged"
			state.authState.token = token
			state.authState.loggedUser = user
			localStorage.setItem("logged", JSON.stringify(user))
			// localStorage.setItem("token", JSON.stringify(token))
		},
		updateLoggedUser(state, user) {
			state.authState.loggedUser = user
			localStorage.setItem("logged", JSON.stringify(user))
		},
		savePromotorCode(state, promotorCode) {
			state.promotorCode = promotorCode
			localStorage.setItem("promotorCode", promotorCode)
		},
		logout(state) {
			state.authState.token = ""
			state.authState.loggedUser = {}
			state.authState.status = "notlogged"
			localStorage.removeItem("logged")
			localStorage.removeItem("token")
		}
	}
})
